module.exports = __webpack_public_path__ + "static/favicon-8ebf434c95bf478521cdffa5b5e3cdf2.ico";